import React, { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface ProfilePictureProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  className?: string;
}

const ProfilePicture = forwardRef<HTMLDivElement, ProfilePictureProps>(
  ({ className, src, alt = 'U', ...props }, ref) => {
    return (
      <Avatar
        ref={ref}
        className={cn(
          'w-[32px] h-[32px] object-cover rounded-full border-gradient border-[1.5px] bg-gray-500 flex items-center justify-center',
          className
        )}
        {...props}
      >
        <AvatarImage
          className="rounded-full w-full h-full"
          src={src}
          alt={alt}
        />
        <AvatarFallback className="text-lg font-medium">
          {alt.charAt(0)}
        </AvatarFallback>
      </Avatar>
    );
  }
);

ProfilePicture.displayName = 'ProfilePicture';

export default ProfilePicture;
